module.exports = __webpack_public_path__ + "static/media/ky.daa525ed.svg";